import Vue from 'vue';
import shippingProviderTransformer from './../../transformers/shippingProvider';
import store from '../../store';

const success = ({ data }, resolve) => {
  const shippingProvider = shippingProviderTransformer.fetch(data);
  resolve(shippingProvider);
  store.dispatch('fetchCurrentShippingProvider', shippingProvider);
};

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/shipping_providers/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/shippingProvider/show.js